<app-form-manager
  formPlugin="core-mapping-spreadsheet-execution-details-form"
  [params]="params"
  (canceled)="cancel($event)"
  (saveSucceed)="saveSucceed($event)"
  #form>
</app-form-manager>
